module.exports = __webpack_public_path__ + "img/collect.48afdba6.svg";